import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Event, EventService, TicketType } from '@smartnowx/hcms-plugin-event-manager';
import { Ticket } from 'src/app/entity/Ticket';
import { TicketResponse } from 'src/app/entity/TicketResponse';
import { TicketValidationStatus } from 'src/app/entity/TicketValidationStatus';
import { PromotionCodeService } from 'src/app/service/promotion-code.service';
import { TicketSaleService } from 'src/app/service/ticket-sale.service';
import { UserService } from 'src/app/service/user.service';
import { PromotionCodeValidatorFactory } from 'src/app/validators/promotion-code.validator';
import { environment } from 'src/environments/environment';
import { v4 } from 'uuid';

@Component({
  selector: 'app-sale-form',
  templateUrl: './sale-form.component.html',
  styleUrl: './sale-form.component.scss',
  standalone: false,
})
export class SaleFormComponent implements OnInit {  

  saleForm!: FormGroup;

  @Input() 
  ticket_type_id:  number = 0;

  ticketType: TicketType | undefined; 

  event: Event | undefined;

  scan: boolean = false;

  discount : number = 0;

  mode: string = 'sale';

  ticketResponse: TicketResponse = { status: TicketValidationStatus.UNKNOWN } as TicketResponse;

  offline: boolean = false;

  constructor(private formBuilder: FormBuilder, private eventService: EventService, private ticketSaleService: TicketSaleService, private promotionCodeValidatorFactory: PromotionCodeValidatorFactory, private userService: UserService) {
    this.saleForm = this.formBuilder.group({
      quantity: [1, [Validators.required, Validators.min(1)]],
      email: [null, [Validators.email]],
      promo_code: [null, [Validators.maxLength(12)], [this.promotionCodeValidatorFactory.createValidator()]],
      payment_method: [null, Validators.required],
    });
    
  }

  ngOnInit(): void {
    
    this.ticketType = this.retrieveFromSessionStorage(this.ticket_type_id);

    console.log('Ticket Type for ID', this.ticket_type_id, ':', this.ticketType);

    if (!this.ticketType) {
      console.error('Ticket Type not found for ID:', this.ticket_type_id);
      return;
    }

    this.eventService.getEvent(this.ticketType.event_id).subscribe({
      next: (event) => {
        this.event = event;
      }
    });

  }

  updateQuantity(number: number = 0) {

    const currentQuantity = this.saleForm.value.quantity || 0;
    if(currentQuantity+number > 0){
      this.saleForm.patchValue({ quantity: this.saleForm.value.quantity + number });
    }
  }

  scanPromoCode(){
    this.scan = !this.scan;
  }

  scanSuccessHandler(result: string) {
    console.log('Scanned promo code:', result);
    this.saleForm.patchValue({ promo_code: result.replace(/^0+/, '') });
    this.scan = false;
  }

  public reset(){
    this.ticketResponse = { status: TicketValidationStatus.UNKNOWN } as TicketResponse;
  }

  sellTicket() {

    if (this.saleForm.invalid) {
      console.log('Form is invalid:');
      this.logFormValidationErrors(this.saleForm);
      this.saleForm.markAllAsTouched();
      return;
    }

    if(!this.ticketType){
      return;
    }
    /* IDEA: Store locally and bulk sync */
    this.ticketSaleService.sellTicket({
      name: v4(),
      ticket_type_ids: [this.ticketType.id],
      quantity: this.saleForm.value.quantity,
      email: this.saleForm.value.email || environment.DEFAULT_CUSTOMER_EMAIL,
      promo_code: this.saleForm.value.promo_code || null,
      payment_method: this.saleForm.value.payment_method,
      retail_id: environment.DEFAULT_RETAILER_ID,
      seller_id: this.userService.getUser().id,
    }).subscribe({
      next: (response) => {
        console.log('Ticket sold successfully:', response);
        this.ticketResponse = { 
          status: TicketValidationStatus.SUCCESS,
          message: 'Ticket sold successfully',
          ticket: {
            id: 0,
            ticket_type: this.ticketType,
            transaction_id: (response as any).transaction_id,
            status: 1,
            validity_token: v4(),
            created_at: new Date(),
            laravel_through_key: 0
          } as Ticket,
         } as TicketResponse;

         this.resetForm();

      },
      error: (error) => {     
        console.error('Error selling ticket:', error);
        this.ticketResponse = {
          status: TicketValidationStatus.ERROR,
          message: 'Something went wrong while selling the ticket: ' + error.message,
        } as TicketResponse;
      }
    });    

 
  }

  public resetForm(){
    this.saleForm.reset({
      quantity: 1,
      email: null,
      promo_code: null,
      payment_method: null,
     });
  }

  public applyDiscount(): void{

    if(this.saleForm.get('promo_code')?.valid){
      this.promotionCodeValidatorFactory.lastValidPromotionCode$.subscribe((response) => {
        if(response && response.type === 'FIXED') {
          this.discount = response.value;
        } else if(response && response.type === 'PERCENTAGE') {
          this.discount = (this.ticketType?.price || 0) * (response.value / 100);
        } else {
          this.discount = 0;
        }
      });
      
    } else {
      this.discount = 0;
    }

  }
    

  private retrieveFromSessionStorage(ticket_type_id: number): TicketType | undefined {
    const raw = sessionStorage.getItem('ticketTypes');


    const types = raw ? JSON.parse(raw) : null;

    if(types === null || types.length === 0) {
      console.warn('No ticket types found in session storage.');
      return undefined;
    }

    return types.find((ticketType: any) => ticketType.id == ticket_type_id);  
  }

  logFormValidationErrors(formGroup: FormGroup): void {
    Object.keys(formGroup.controls).forEach((key) => {
      const control = formGroup.get(key);
      if (control && control.invalid) {
        console.warn(`Hibás mező: ${key}`, control.errors);
      }
  
      // ha nested FormGroup lenne
      if (control instanceof FormGroup) {
        this.logFormValidationErrors(control);
      }
    });
  }

}
